import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, SearchCriteria,SearchResult } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css']
})

export class SearchResultComponent implements OnInit {

  @Input()
  result: SearchResult;

  sanitizer: DomSanitizer;

  get resultHtml(): string {
    //console.log(this.sanitizer.bypassSecurityTrustHtml(this.result.html));
    //return this.sanitizer.bypassSecurityTrustHtml(this.result.html).toString();
    return this.result.html;
  }

  config: AppConfig;

  constructor(private facetedSearchAppService: FacetedSearchAppService, private domSanitizer: DomSanitizer) {
    this.sanitizer = domSanitizer;
  }

  ngOnInit(): void {
    //this.facetedSearchAppService.appConfig().then(x => {
    //  this.config = x;
    //});
  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/search-result/search-result.component.ts